// Orders/TabContent/OrderHistory.js
import React from "react";

const PendingOrders = () => {
  return (
    <div className="p-6">
      <h3 className="text-lg font-bold">Pending Orders</h3>
      <p className="text-gray-600">
      Pending orders and status updates will be displayed here.
      </p>
    </div>
  );
};

export default PendingOrders;
